import { ReactNode } from 'react'
import { Alert } from '@mui/material'
import { useMapReauthenticationError } from './ReauthenticationDialog.utils'

interface ReauthenticationNoticesProps {
  // Consequence of the action the user reauthenticates for
  warning?: ReactNode
  error?: string | null
}

const ReauthenticationNotices = ({
  warning,
  error,
}: ReauthenticationNoticesProps) => {
  const { mapError } = useMapReauthenticationError()

  return (
    <>
      {warning && (
        // Full width, as a warning may have a progress bar
        <Alert
          severity="warning"
          sx={{ '& .MuiAlert-message': { flexGrow: 1 } }}
        >
          {warning}
        </Alert>
      )}
      {error && <Alert severity="error">{mapError(error)}</Alert>}
    </>
  )
}

export default ReauthenticationNotices
